<template>
    <div class="statistics">
        <div>
            <div>
                <div class="classInp">
                    <el-input
                        class="searchInp"
                        placeholder="请输入分类名"
                        prefix-icon="el-icon-search"
                        v-model="searchVal">
                    </el-input>
                    <el-button type="primary" @click="searchClass">搜索</el-button>
                </div>
                <div class="classStatics">
                    <el-table
                        :data="classData"
                        border
                        style="width: 100%"
                        :header-cell-style="{'text-align':'center'}"
                        :cell-style="{'text-align':'center'}">
                        <el-table-column
                        prop="name"
                        label="分类">
                        </el-table-column>
                        <el-table-column
                        prop="books"
                        label="书籍量">
                        </el-table-column>
                    </el-table>
                    <pager :total-page="classStaticsTotalPage" :initPage="classStaticsPageNum" @go-page="goClassStaticsPageNum" v-if="isShowClassPager" />
                </div>
            </div>
            <div>
                <div class="dateInput">
                    <el-date-picker
                        v-model="value"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy/MM/dd"
                        @change="statisticsCount">
                    </el-date-picker>
                </div>
                <div class="numStatics">
                    <el-table
                        :data="numData"
                        border
                        style="width: 100%"
                        :header-cell-style="{'text-align':'center'}"
                        :cell-style="{'text-align':'center'}">
                        <el-table-column
                        prop="date"
                        label="时间">
                        </el-table-column>
                        <el-table-column
                        prop="clicks"
                        label="点击量">
                        </el-table-column>
                        <el-table-column
                        prop="plays"
                        label="播放量">
                        </el-table-column>
                    </el-table>
                    <pager :total-page="totalPage" :initPage="pageNum" @go-page="goPageNum" v-if="isShowPager" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
let vm = null;
import pager from './pager.vue'
export default {
    components: {
        pager
    },
    data() {
        return {
            value: [],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > new Date();
                }
            },
            pageNum: 1,
            totalPage: 1,
            isShowPager: false,
            numData: [],
            listCount: {},
            searchVal: '',
            classStaticsTotalPage: 1,
            classStaticsPageNum: 1,
            isShowClassPager: false,
            classData: [],
            classCount: {}
        }
    },
    mounted() {
        let that = this;
        vm = this;
        let date = new Date();
        let a = date.getFullYear() + "/" + ( date.getMonth() + 1 ) + "/" + date.getDate();
        that.value = [a,a];
        that.statisticsCount();
        that.classBooksCount();
        
    },
    methods: {
        statisticsCount() {
            let that = this;
            let data = {
                date: {
                    begin: that.value[0],
                    end: that.value[1]
                }
            }
            that.allApi.statisticsCount(data).then((resource)=>{
                console.log(resource.data.data)
                if( resource.data.code == 200 ) {
                    that.listCount = resource.data.data;
                    that.getList();
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        getList() {
            let that = this;
            let data = {
                page: that.pageNum,
                size: 10,
                date: {
                    begin: that.value[0],
                    end: that.value[1]
                }
            }
            that.allApi.statisticsList(data).then((resource)=>{
                // console.log(resource.data.data)
                if( resource.data.code == 200 ) {
                    that.numData = resource.data.data.list;
                    that.numData.unshift(that.listCount);
                    that.pageNum = resource.data.data.page;
                    if( that.pageNum == 1 ) {
                        that.totalPage = resource.data.data.pages;
                        if( that.totalPage > 1 ) {
                            that.isShowPager = true;
                        }else{
                            that.isShowPager = false;
                        }
                    }
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        goPageNum(obj) {
            let that = this;
            that.pageNum = obj.page;
            that.statisticsCount();
        },
        classBooksCount() {
            let that = this;
            let data = {
                search: {
                    search: that.searchVal
                }
            }
            that.allApi.classBooksCount(data).then((resource)=>{
                console.log(resource.data.data)
                if( resource.data.code == 200 ) {
                    that.classCount = {
                        name: '全部分类',
                        books: resource.data.data
                    };
                    that.getClassList();
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        getClassList() {
            let that = this;
            let data = {
                page: that.classStaticsPageNum,
                size: 10,
                search: {
                    search: that.searchVal
                }
            }
            that.allApi.classBooksPage(data).then((resource)=>{
                // console.log(resource.data.data)
                if( resource.data.code == 200 ) {
                    that.classData = resource.data.data.list;
                    that.classData.unshift(that.classCount);
                    that.classStaticsPageNum = resource.data.data.page;
                    if( that.classStaticsPageNum == 1 ) {
                        that.classStaticsTotalPage = resource.data.data.pages;
                        if( that.classStaticsTotalPage > 1 ) {
                            that.isShowClassPager = true;
                        }else{
                            that.isShowClassPager = false;
                        }
                    }
                }else if( resource.data.code == 401 ){
                    that.$router.push("/")
                }
            })
        },
        searchClass() {
            let that = this;
            that.classStaticsPageNum = 1;
            that.classBooksCount();
        },
        goClassStaticsPageNum(obj) {
            let that = this;
            that.classStaticsPageNum = obj.page;
            that.getClassList();
        }
    }
}
</script>

<style lang="scss" scoped>
    .statistics{
        >div{
            margin: 0 auto;
            width: 1200px;
            display: flex;
            justify-content: space-around;
            >div{
                >.dateInput{
                    text-align: center;
                    margin-bottom: 30px;
                }
                >.classInp{
                    margin-bottom: 30px;
                    display: flex;
                    justify-content: center;
                    >.searchInp{
                        width: 300px;
                        margin-right: 10px;
                    }
                }
                >.numStatics,
                >.classStatics{
                    margin-bottom: 30px;
                }
            }
        }
    }
</style>
<style lang="scss">
    .el-date-editor .el-range-separator{
        box-sizing: unset;
    }
</style>